import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as vars from "../../constants/variables";
import { show, hide } from "../../actions/ActivityIndicatorActions";
import { checkAccess } from "../../actions/WelcomeActions";
import { getDetails, getInterests } from "../../actions/AccountActions";
import axios from "axios";
import isIos from "is-ios";
import { config } from "../../constants/domainConfig";
import { isCategoryAllowed } from "../../constants/restrictedCategories";
import { Row, Col } from "reactstrap";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import { console_log, appendUid } from "../../utils/helper";
import { sendData } from "../../analytics/sendData";
import { getGames } from "../../actions/GamesActions";
import { getCategories } from "../../actions/CategoryActions";
import { isGamiclub } from "./../../constants/isGamiclub";
import { isOnlyBeemobi } from "../../constants/isOnlyBeemobi";
import {
  parse,
  isvalid,
  getPlaceHolder,
  getFlag,
} from "../../utils/login.utils";
import { isAppspool } from "../../constants/isAppspool";
import { isTheGamingClubs } from "../../constants/isTheGamingClubs";
import { isGamezClan } from "../../constants/isGamezClan";
import { isOnlyMobbfun } from "../../constants/isOnlyMobbfun";
import {
  isFunzarena,
  isGameflares,
  isGamiway,
} from "../../constants/productCondition";
import { peHEURL } from "../../constants/heURL";
import { getDomainTheme } from "../../utils/domainTheme.js";
const getErrorMessages = () => {
  switch (config.subDomain) {
    case "pt":
      return {
        phoneNumberRequired: "Número de telefone necessário",
        invalidNumber: "Número inválido",
        subNotFound: "Assinatura não encontrada",
      };
    default:
      return {
        phoneNumberRequired: "Phone number required",
        invalidNumber: "Invalid Number",
        subNotFound: "Subscription not found",
      };
  }
};

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      msisdn: "",
      isValid: false,
      errorMessage: "",
      domain: window.location.host,
      notFound: false,
      reason: "",
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeMsisdn = this.onChangeMsisdn.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.callAuthenticate = this.callAuthenticate.bind(this);
    this.callUserApis = this.callUserApis.bind(this);
    this.getCategories = this.getCategories.bind(this);
    this.getGames = this.getGames.bind(this);
  }

  componentDidMount() {}

  onChangeMsisdn(e) {
    this.setState({ msisdn: e.target.value });
  }

  onKeyUp(e) {
    if (e.keyCode == 13) {
      this.onSubmit(e);
    }
  }

  onSubmit(e) {
    e.preventDefault();
    if (isvalid(this.state.msisdn, config.country)) {
      const msisdn = parse(this.state.msisdn, config.country);
      this.setState({ isValid: true, errorMessage: "" });
      this.callAuthenticate({
        msisdn: msisdn,
      });
    } else {
      if (!this.state.msisdn) {
        this.setState((prev) => ({
          ...prev,
          isvalid: false,
          notFound: false,
          errorMessage: getErrorMessages().phoneNumberRequired,
        }));
      } else {
        this.setState((prev) => ({
          ...prev,
          isValid: false,
          notFound: false,
          errorMessage: getErrorMessages().invalidNumber,
        }));
      }
    }
  }

  callAuthenticate(data) {
    this.props.show();
    let domain = window.location.host;
    if (window.location.host.indexOf("local") >= 0)
      domain = `${config.subDomain}.gamiclub.com`;
    axios
      .get(
        vars.BASE_URL +
          `/checkAccessWithMsisdn?msisdn=${data.msisdn}&domain=${domain}`,
      )
      .then((response) => {
        if (response.data.success) {
          let data = {
            success: response.data.success,
            uid: response.data.data.payload.token,
            token: response.data.data.token,
            subscriptionData: response.data.data.payload,
          };
          sessionStorage.setItem("authorized", JSON.stringify(data));
          sendData("", "", "", "Accessed", {
            method: "msisdn",
            status: "success",
            url: window.location.href,
            rid: data.subscriptionData.rockmanId,
          });
          this.props.checkAccess(data);
          axios.defaults.headers.common["authorization"] =
            response.data.data.token;
          this.getCategories();
          this.getGames(data.uid)
            .then(() => {
              this.callUserApis(data.uid);
            })
            .then(() => {
              console.log("call apis was successful");
              this.props.hide();
              this.props.history.push(appendUid("/welcome", data.uid));
            })
            .catch((err) => {
              console.log(err);
              this.props.hide();
              this.props.history.push("/login");
            });
        } else {
          this.setState({
            notFound: true,
            reason: getErrorMessages().subNotFound,
          });
          this.props.hide();
        }
      })
      .catch((error) => {
        this.props.hide();
        console.log(error);
        this.props.history.push("/restricted");
      });
  }
  callUserApis(uid) {
    return new Promise((resolve, reject) => {
      if (this.props.account.interests.length <= 0) {
        axios
          .all([axios.get(`${vars.BASE_URL}/interests?uid=${uid}`)])
          .then(
            axios.spread((interests) => {
              if (interests.data.data) {
                this.props.getInterests(interests.data.data);
              }
              resolve();
            }),
          )
          .then(() => {
            axios
              .get(`${vars.BASE_URL}/getUserProfile?uid=${uid}`)
              .then((resp) => {
                if (resp.data.data) {
                  this.props.getDetails(resp.data.data);
                }
              })
              .catch((err) => {
                console.log(
                  "error in getting user profile twosteplogin1111-------- ",
                  err,
                );
              });
          })
          .catch((err) => {
            console_log(err);
            reject(err);
          });
      } else {
        this.props.getDetails(this.props.account.user);
        this.props.getInterests(this.props.account.interests);
        resolve();
      }
    });
  }
  getCategories() {
    axios
      .get(vars.BASE_URL + "/getCategories")
      .then((response) => {
        if (response.data.success) {
          let dataFinal = response.data;
          let categoriesArr = dataFinal.data;
          dataFinal = { ...dataFinal, data: categoriesArr };
          dataFinal.data = dataFinal.data.filter((category) => isCategoryAllowed(category.categoryName));
          if (!(config.subDomain === "cz" && isGamiclub)) {
            dataFinal.data = dataFinal.data.filter((category) => {
              return category.categoryName != "E-knihy";
            });
          }
          if (config.subDomain === "fr" && isGamiclub) {
            dataFinal.data = dataFinal.data.filter((category) => {
              return category.categoryName != "Heróis Verdes";
            });
          }
          if (
            config.subDomain === "my" &&
            window.location.hostname.includes("gamiclub")
          ) {
            dataFinal.data = dataFinal.data.filter((category) => {
              let excludes = [
                "E-Learning",
                "Heróis Verdes",
                "Meu Emprego dos Sonhos",
                "Political & Activism",
              ];
              return excludes.indexOf(category.categoryName) == -1;
            });
          }
          if (
            config.subDomain === "es2" &&
            window.location.hostname.includes("beemobi")
          ) {
            dataFinal.data = dataFinal.data.filter((category) => {
              let excludes = [
                "E-Learning",
                "Heróis Verdes",
                "Meu Emprego dos Sonhos",
              ];
              return excludes.indexOf(category.categoryName) == -1;
            });
          } else {
            dataFinal.data = dataFinal.data.filter((category) => {
              return category.categoryName != "Videos Virales";
            });
          }
          if (config.subDomain !== "rs") {
            dataFinal.data = dataFinal.data.filter((category) => {
              return category.categoryName != "Е-књиге";
            });
          }
          if (
            config.subDomain !== "tr" &&
            config.subDomain !== "qa" &&
            config.subDomain !== "kw"
          ) {
            dataFinal.data = dataFinal.data.filter((category) => {
              return category.categoryName != "Facebook";
            });
          }
          this.props.getCategories(dataFinal);
          return;
        }
      })
      .catch((error) => {
        console_log(error);
        this.setState({
          isValid: false,
          errorMessage: "Unable to fetch the data.",
        });
        return;
      });
  }

  getGames(uid) {
    return new Promise((resolve, reject) => {
      axios
        .get(vars.BASE_URL + "/getGames?uid=" + uid)
        .then((response) => {
          if (response.data.success) {
            response.data.data = response.data.data.filter((game) => isCategoryAllowed(game.categoryName));
            if (!(config.subDomain == "tr" || config.subDomain == "no")) {
              response.data.data = response.data.data.filter((game) => {
                return (
                  game.gameTitle != "Trusted Tarot" &&
                  game.gameTitle != "Coffee Reading"
                );
              });
            }
            this.props.getGames(response.data);
          }
          resolve();
        })
        .catch((error) => {
          console_log(error);
          this.setState({
            isValid: false,
            errorMessage: "Unable to fetch the data.",
          });
          reject(error);
        });
    });
  }

  render() {
    if (
      !isGamiclub &&
      config.subDomain === "pe" &&
      window.location.href.includes("login")
    ) {
      if (window.location.search.includes("show-login=true"))
        window.location.href = "https://loginprime.com/GOaAZO";
      else window.location.href = peHEURL;
      return null;
    } else if (
      !isGamiclub &&
      config.subDomain === "pe-staging" &&
      window.location.href.includes("login")
    ) {
      window.location.href = "https://loginprime.com/0Pj1KO";
      return null;
    }
    const flag_url = getFlag(config.country);
    const theme = getDomainTheme();
    let uid = this.props.access.uid;
    console.log("theme", theme);

    return (
      <div className="login animated fadeIn">
        <Row className="justify-content-center">
          <Col>
            <Row className="login-page-header">
              <img
                className={
                  isOnlyMobbfun
                    ? "login-page-logo-mobbfun login-page-logo"
                    : "login-page-logo"
                }
                src={theme.logo}
                alt="GameLord"
              />
            </Row>
            <Row className="login-page-content">
              <h1>
                <FormattedMessage
                  id="areYouAlready"
                  defaultMessage={`Are you already a member of `}
                />
                {theme.productName ? theme.productName : "Gamelords"}?
              </h1>
              <p>
                {config.subDomain === "za" && isIos ? (
                  <FormattedHTMLMessage
                    id="thenConfirmAlt"
                    defaultMessage="Then confirm your mobile number and get unlimited access to all our <strong> HTML5 </strong> games and <strong> videos </strong>"
                  />
                ) : (
                  <FormattedHTMLMessage
                    id="thenConfirm"
                    defaultMessage="Then confirm your mobile number and get unlimited access to all our <strong> HTML5 </strong> and <strong> Android </strong> games"
                  />
                )}
              </p>

              <div className="login-page-mobile_num">
                {flag_url ? (
                  <div className="flag_img">
                    <img src={flag_url} className="flag_url" />
                  </div>
                ) : null}

                <input
                  autoFocus
                  type="number"
                  name="msisdn"
                  value={this.state.msisdn}
                  onChange={this.onChangeMsisdn}
                  onKeyUp={this.onKeyUp}
                  className="LoginRoute-number"
                  placeholder={getPlaceHolder(config.country)}
                  style={flag_url ? { textIndent: "41px" } : {}}
                />
                <button
                  type="submit"
                  onClick={this.onSubmit}
                  style={
                    isGamiclub
                      ? { backgroundColor: "green" }
                      : isGameflares
                        ? { backgroundColor: "#FF394B" }
                        : isGamiway
                          ? { backgroundColor: "#b347a0" }
                          : null
                  }
                  className="LoginRoute-button"
                >
                  <FormattedMessage id="login" defaultMessage="Login" />
                  <i className="icon-back"></i>
                </button>
                {this.state.notFound ? (
                  <span className="error-message">{this.state.reason}</span>
                ) : !this.state.isValid ? (
                  <span className="error-message">
                    {this.state.errorMessage}
                  </span>
                ) : null}
              </div>
              {isFunzarena && (
                <a className="navigate-link" href="#/terms-conditions">
                  <span>
                    <FormattedMessage
                      id="tnc"
                      defaultMessage="Terms &amp; Conditions"
                    />
                  </span>
                </a>
              )}
            </Row>
          </Col>
        </Row>
      </div>
    );
    //}
    //else return (<MsisdnNotFound reason={this.state.reason} />)
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.AuthenticationReducer,
    loader: state.ActivityIndicatorReducer,
    access: state.WelcomeReducer,
    account: state.AccountReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      // authenticate,
      checkAccess,
      show,
      hide,
      getDetails,
      getInterests,
      getGames,
      getCategories,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Login/Login.js